import { CompanyResponse } from '@yard/app/api'
import { companyService, ICompanyService } from '@yard/services/company.service'
import { computed, makeObservable, observable, runInAction } from 'mobx'

export class CompanyStore {
  companies: CompanyResponse[] = []

  constructor(private readonly service: ICompanyService = companyService) {
    makeObservable(this, {
      companies: observable,
      byId: computed,
    })
  }

  async loadCompanies(): Promise<void> {
    const companies = await this.service.getAll()
    runInAction(() => {
      this.companies = companies
    })
  }

  get byId(): Map<number, CompanyResponse> {
    return new Map(this.companies.map(c => [c.id, c]))
  }

  // Resolves an operatorId to a human-readable display name.
  // Order of preference: shortName -> name -> `Unknown (id:N)`.
  displayNameFor(id: number): string {
    const company = this.byId.get(id)
    if (company?.shortName) return company.shortName
    if (company?.name) return company.name
    return `Unknown (id:${id})`
  }
}
